/**
 * ImageLightbox — full-size viewer for Debug Session screenshots (the tray
 * thumbnails and the Sessions-panel images open here). Plain fixed overlay,
 * no deps; z 30000 sits above the debug HUD (20000) and every app surface,
 * below only the picker layer. Click anywhere or Esc closes.
 */
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const ImageLightbox: React.FC<{ url: string; onClose: () => void }> = ({ url, onClose }) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') { e.stopPropagation(); onClose(); } };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [onClose]);

  return createPortal(
    <div
      data-debug-overlay="true"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 30000, background: 'rgba(0,0,0,0.82)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-out',
      }}
    >
      <img
        src={url}
        alt="screenshot (full size)"
        style={{ maxWidth: '94vw', maxHeight: '94vh', objectFit: 'contain', boxShadow: '0 8px 40px rgba(0,0,0,0.6)', borderRadius: 4 }}
      />
      <div style={{ position: 'fixed', top: 12, right: 16, color: '#fff', font: '12px system-ui', opacity: 0.8 }}>
        click anywhere or Esc to close
      </div>
    </div>,
    document.body,
  );
};

export default ImageLightbox;
